/** 前台 Middleware */
export default defineNuxtRouteMiddleware(() => {
  const localePath = useLocalePath()

  const authStore = useAuthStore()
  const { accountNo } = storeToRefs(authStore)

  if (!accountNo.value) {
    return navigateTo(localePath('index'))
  }
})
